import React from 'react';
import { connect } from 'react-redux';

const Personas = (props) => {
    return (
        <div 
            className="slds-p-around_x-small" 
            style={{ color: 'white' }}
        >
            {Object.keys(props.personas).map((value) => {
                return (
                    <div className="slds-grid slds-m-vertical_x-small">  
                        <div className="slds-size_1-of-4 slds-align_absolute-center slds-p-horizontal_xx-small">
                            <button 
                                alt={props.personas[value].name}
                                style={{ 
                                    height: '40px',
                                    width: '40px',
                                    borderRadius: '50%',
                                    backgroundImage: 'url(' + props.personas[value].picUrl + ')',
                                    backgroundSize: '150%',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                }}
                            />
                        </div>
                        <div className="slds-size_3-of-4 slds-p-left_small">
                            <div>{props.personas[value].name}</div>
                            <div>{props.personas[value].role}</div>
                        </div>
                    </div>
                )
            })}
        </div>
    );
}

const mapStateToProps = (state) => ({
    personas: state.personas
});

export default connect(mapStateToProps)(Personas);
